"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _ = _interopRequireWildcard(require("lodash"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./newQnaPostForm.scss");

var _form = _interopRequireDefault(require("antd/lib/form"));

var _qna = require("../../redux/qna/qna.types");

var _HMPTextArea = _interopRequireDefault(require("../../components/textarea/HMPTextArea"));

var _FroalaCustomUpload = _interopRequireDefault(require("../activity/FroalaCustomUpload"));

var _Util = require("../util/Util");

var _util = require("../../service/util");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  confirm
} = _modal.default;
const {
  Item
} = _form.default;
const {
  Option
} = _select.default;
const defaultPost = {
  id: undefined,
  topicId: undefined,
  question: '',
  answer: '',
  topic: '',
  isAnswered: true,
  isPrivate: false,
  answeredByUserId: -1,
  createDate: new Date(),
  lastUpdateDate: new Date(),
  username: '',
  answeredByUsername: '',
  deleteDate: null,
  threadId: null,
  tags: '',
  thumbsups: [],
  favorites: [],
  comments: [],
  adHocNotifications: [],
  createdByParticipantId: -1
};
const itemStyle = {
  marginBottom: '10px',
  marginTop: '10px'
};
const charLimit = 2000;
const MEDIUMTEXT = 16777215;

class QnaFormContainer extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = {
      post: defaultPost
    };
    this.form = /*#__PURE__*/_react.default.createRef();

    this.renderTitle = () => {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "qna-form-title"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "qna-title-text"
      }, "Create/Edit Post"));
    };

    this.handleSave = () => {
      if (this.form.current) {
        this.form.current.validateFields().then(() => {
          confirm({
            title: 'Are you sure you want to post this?',
            content: '',
            okText: 'Confirm',
            onOk: () => {
              this.handleSaveQnaPost();
            },

            onCancel() {}

          });
        });
      }
    };

    this.handleSaveQnaPost = async () => {
      const {
        closeHandler,
        createQnaPost,
        updateQnaPost
      } = this.props;
      const {
        post
      } = this.state;
      const {
        question,
        answer
      } = post;
      post.question = (0, _util.cleanstring)(question);
      post.answer = answer ? (0, _util.cleanstring)(answer) : '';

      if (post.id) {
        updateQnaPost(post);
      } else {
        createQnaPost(post);
      }

      this.resetState();
      closeHandler();
    };

    this.resetState = () => {
      const resetState = _.cloneDeep({
        post: defaultPost
      });

      this.setState(resetState);
    };

    this.handleCancel = () => {
      const {
        closeHandler
      } = this.props;
      confirm({
        title: 'Are you sure you want to leave this post?',
        content: 'You will lose all changes.',
        okText: 'Leave',
        okType: 'danger',
        onOk: () => {
          this.resetState();
          closeHandler();
        },

        onCancel() {}

      });
    };

    this.onTopicIdChange = id => {
      const {
        post
      } = this.state;
      post.topicId = id;
      this.setState({
        post
      });
    };

    this.onQuestionChange = e => {
      const {
        post
      } = this.state;
      post.question = e.target.value;
      this.setState({
        post
      });
    };

    this.onAnswerChange = value => {
      const {
        post
      } = this.state;
      post.answer = (0, _Util.updateCmsEditorBeforeSave)(value);
      this.setState({
        post
      });
    };

    this.characterLimit = (s, limit) => {
      if (s) {
        if (s.length <= limit) {
          return `(${limit - s.length} characters left.)`;
        }

        return `(${s.length - limit} characters over character limit.)`;
      }

      return `(${limit} characters left)`;
    };
  }

  componentDidMount() {
    const {
      post
    } = this.props;

    if (post && post.id) {
      this.setState({
        post
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.visible && prevProps.post && this.form.current) {
      this.form.current.setFieldsValue({
        topicId: prevProps.post.topicId,
        question: prevProps.post.question,
        answer: prevProps.post.answer
      });
    }
  }

  render() {
    const {
      visible,
      topics
    } = this.props;
    const {
      post
    } = this.state;
    const {
      topicId,
      question,
      answer
    } = post;
    const footerActions = [/*#__PURE__*/_react.default.createElement(_button.default, {
      key: "cancel",
      type: "default",
      onClick: this.handleCancel
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
      key: "primary",
      type: "primary",
      onClick: this.handleSave
    }, "Post")];
    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: this.renderTitle(),
      visible: visible,
      onOk: this.handleSave,
      onCancel: this.handleCancel,
      footer: footerActions,
      closable: false,
      destroyOnClose: true,
      width: "50%",
      style: {
        minWidth: '800px'
      }
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: this.form,
      key: "post-form",
      className: "new-qna-post-form",
      layout: "vertical",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, {
      key: "post-form-topic",
      name: "topicId",
      label: "Topic:",
      style: itemStyle,
      rules: [{
        required: true,
        message: 'Type is required.'
      }],
      initialValue: topicId
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      showSearch: true,
      onChange: this.onTopicIdChange,
      style: {
        width: 'auto',
        minWidth: 200
      },
      placeholder: "Choose a topic",
      optionFilterProp: "value",
      filterOption: (input, option) => {
        const current = topics === null || topics === void 0 ? void 0 : topics.find(t => t.id === (option === null || option === void 0 ? void 0 : option.props.value));

        if (current) {
          return current.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }

        return false;
      }
    }, topics && _.map(_.sortBy(topics, 'title'), topic => /*#__PURE__*/_react.default.createElement(Option, {
      key: `option-${topic.id}`,
      value: topic.id
    }, topic.title)))), /*#__PURE__*/_react.default.createElement(Item, {
      key: "post-form-label",
      name: "question",
      label: "Question:",
      style: itemStyle,
      rules: [{
        required: true,
        message: `Question is required.`
      }, {
        max: charLimit,
        message: `${question.length - charLimit} characters over`
      }],
      initialValue: question
    }, /*#__PURE__*/_react.default.createElement(_HMPTextArea.default, {
      spellCheck: true,
      maxRows: 8,
      onChange: this.onQuestionChange,
      placeholder: "Question text",
      characterLimit: charLimit
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: "post-form-answerhtml",
      name: "answer",
      label: "Answer:",
      style: itemStyle,
      rules: [{
        required: true,
        message: `Answer is required.`
      }, {
        max: MEDIUMTEXT,
        message: `${answer ? answer.length - MEDIUMTEXT : 0} characters over. Consider using less stylized text or mark up.`
      }],
      valuePropName: "model",
      initialValue: answer
    }, /*#__PURE__*/_react.default.createElement(_FroalaCustomUpload.default, {
      onChange: this.onAnswerChange,
      charLimit: charLimit
    })))));
  }

}

const mapStateToProps = state => {
  return {
    participants: selectors.getRequestedStudyParticipantsWithUsernames(state),
    topics: selectors.getQnaTopics(state)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createQnaPost: post => dispatch(_qna.createQnaPostAsync.request(post)),
    updateQnaPost: post => dispatch(_qna.updateQnaPostAsync.request(post))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(QnaFormContainer);

exports.default = _default;